import TransactionReportList from './TransactionReportList';

const transactiondetails = {
  list: TransactionReportList,
};

export default transactiondetails;
